/** @file Scale drag: local scale times the drag factors along the gizmo bone's world X (never snaps). */
import { dragModifiers } from '@pose2d/editor-geometry/dragModifiers';
import { dragScale } from '@pose2d/editor-geometry/dragScale';
import { gizmoHandles } from '@pose2d/editor-geometry/gizmoHandles';
import type { ScalePart } from '@pose2d/editor-geometry/types';
import type { Id } from '@pose2d/format/types';
import type { PreviewValues } from '../../panels/viewport/scene/channelOffset';
import { localValue } from '../../panels/viewport/scene/localValue';
import type { ToolGesture } from '../../panels/viewport/viewportTypes';
import { worldAt } from '../../panels/viewport/worldAt';
import { gizmoFrame } from './gizmoFrame';
import type { GestureStart } from './transformPress';
import { transformCommands } from './transformCommands';

/** Shift makes an axis drag uniform (dragScale's constrain). */
export function scaleGesture({ ctx, edit, bones, part, press }: GestureStart): ToolGesture {
  const frame = gizmoFrame(ctx, bones, 'scale');
  const drag = { part: part as ScalePart, rotation: frame.rotation, origin: frame.origin, start: worldAt(ctx, press) };
  const starts = bones.map((i) => [localValue(ctx.pose, i, 'scaleX'), localValue(ctx.pose, i, 'scaleY')] as const);
  let values = new Map<Id, PreviewValues>();
  return {
    move(p) {
      const f = dragScale(drag, worldAt(ctx, p), dragModifiers(ctx.snap, p).constrain, [1, 1]);
      values = new Map(bones.map((i, k) => [ctx.maps.boneIds[i] ?? '', { scaleX: (starts[k]?.[0] ?? 1) * f[0], scaleY: (starts[k]?.[1] ?? 1) * f[1] }]));
      ctx.setPreview(values);
      ctx.setGizmo({ handles: gizmoHandles('scale', frame), active: drag.part, points: [], lines: [] });
    },
    release: () => transformCommands(edit, values),
    cancel() {},
  };
}
